import { defineMessages } from 'react-intl';

export const parkingManagementMessages = defineMessages({
    parkings: {
        id: 'parkings',
        defaultMessage: 'Parkings',
    },
    lastOpened: {
        id: 'last-opened',
        defaultMessage: 'Last opened',
    },
    allParkings: {
        id: 'all-parkings',
        defaultMessage: 'All parkings',
    },
    viewAllParkings: {
        id: 'view-all-parkings',
        defaultMessage: 'View all parkings',
    },
    customiseParkings: {
        id: 'customise-parkings',
        defaultMessage: 'Customise parkings',
    },
    spots: {
        id: 'spots',
        defaultMessage: 'Spots',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    parkingManagementSectionSubtitle: {
        id: 'parking-management-section-subtitle',
        defaultMessage: 'Manage all your parkings in one place. Open any parking to modify its settings.',
    },
    parkingChangeSuccess: {
        id: 'parking-change-success',
        defaultMessage: 'Parking information changed',
    },
    parkingChangeSuccessDetails: {
        id: 'parking-change-success-details',
        defaultMessage: 'Parking information successfully changed for {name}',
    },
    currentParkingChangeSuccess: {
        id: 'current-parking-change-success',
        defaultMessage: 'Current parking changed',
    },
    currentParkingChangeSuccessDetails: {
        id: 'current-parking-change-success-details',
        defaultMessage: 'You are now viewing parking information about <b>{parkingName}</b>',
    },
    parkingNameSubtitle: {
        id: 'parking-name-subtitle',
        defaultMessage: 'The name of the parking, used for identifying it across SmartPark',
    },
    parkingNamePlaceholder: {
        id: 'parking-name-placeholder',
        defaultMessage: 'e.g. My SmartPark Parking',
    },
    numberOfSpaces: {
        id: 'number-of-spaces',
        defaultMessage: 'Number of spaces',
    },
    numberOfSpacesSubtitle: {
        id: 'number-of-spaces-subtitle',
        defaultMessage: 'The total number of parking spaces available in the parking',
    },
    numberOfSpacesPlaceholder: {
        id: 'number-of-spaces-placeholder',
        defaultMessage: 'e.g. 42',
    },
    addressSubtitle: {
        id: 'address-subtitle',
        defaultMessage: 'The address where the parking is located',
    },
    addressPlaceholder: {
        id: 'address-placeholder',
        defaultMessage: 'e.g. 1234 SmartPark Street',
    },
    countrySubtitle: {
        id: 'country-subtitle',
        defaultMessage: 'The country in which the parking is located',
    },
    backToAllParkings: {
        id: 'back-to-all-parkings',
        defaultMessage: 'Back to all parkings',
    },
    takenSpaces: {
        id: 'taken-spaces',
        defaultMessage: 'taken spaces',
    },
    freeSpaces: {
        id: 'free-spaces',
        defaultMessage: 'Free spaces',
    },
    spaces: {
        id: 'spaces',
        defaultMessage: 'Spaces',
    },
    noDescriptionProvided: {
        id: 'no-description-provided',
        defaultMessage: 'No description provided',
    },
    publicInformation: {
        id: 'public-information',
        defaultMessage: 'Public information',
    },
    adminSettings: {
        id: 'admin-settings',
        defaultMessage: 'Admin settings',
    },
    zones: {
        id: 'zones',
        defaultMessage: 'Zones',
    },
    zoneUserAccess: {
        id: 'zone-user-access',
        defaultMessage: 'Zone user access',
    },
    access: {
        id: 'access',
        defaultMessage: 'Access',
    },
    accesses: {
        id: 'accesses',
        defaultMessage: 'Accesses',
    },
    zoneId: {
        id: 'zone-id',
        defaultMessage: 'Zone ID',
    },
    zoneUserAccessRoles: {
        id: 'zone-user-access-roles',
        defaultMessage: 'Zone user access roles',
    },
    zone: {
        id: 'parking-zone',
        defaultMessage: 'Zone',
    },
    createZoneUserAccessSuccessfulDescription: {
        id: 'create-zone-user-access-successful-description',
        defaultMessage: 'Zone user access {zone_id} has been successfully created.',
    },
    updateZoneUserAccessSuccessfulDescription: {
        id: 'update-zone-user-access-successful-description',
        defaultMessage: 'Zone user access {zone_id} has been successfully updated.',
    },
    deleteZoneUserAccessSuccessfulDescription: {
        id: 'delete-zone-user-access-successful-description',
        defaultMessage: 'Zone user access has been successfully deleted.',
    },
    createZoneUserAccess: {
        id: 'create-zone-user-access',
        defaultMessage: 'Create zone user access',
    },
    editZoneUserAccess: {
        id: 'edit-zone-user-access',
        defaultMessage: 'Edit zone user access',
    },
    deleteZoneUserAccess: {
        id: 'delete-zone-user-access',
        defaultMessage: 'Delete zone user access',
    },
    confirmDeleteZoneUserAccess: {
        id: 'confirm-delete-zone-user-access',
        defaultMessage:
            'Are you sure you want to delete the zone user access with zone id {zone_id}? This action cannot be undone.',
    },
    pointsGroups: {
        id: 'points-groups',
        defaultMessage: 'Points groups',
    },
    pointsGroup: {
        id: 'points-group',
        defaultMessage: 'Points group',
    },
    pointsGroupName: {
        id: 'points-group-name',
        defaultMessage: 'Name',
    },
    pointsGroupPoints: {
        id: 'points-group-points',
        defaultMessage: 'Points',
    },
    createPointsGroupSuccessfulDescription: {
        id: 'create-points-group-successful-description',
        defaultMessage: 'Points group {name} has been successfully created.',
    },
    updatePointsGroupSuccessfulDescription: {
        id: 'update-points-group-successful-description',
        defaultMessage: 'Points group {name} has been successfully updated.',
    },
    deletePointsGroupSuccessfulDescription: {
        id: 'delete-points-group-successful-description',
        defaultMessage: 'The points group has been successfully deleted.',
    },
    createPointsGroup: {
        id: 'create-points-group',
        defaultMessage: 'Create points group',
    },
    editPointsGroup: {
        id: 'edit-points-group',
        defaultMessage: 'Edit points group',
    },
    deletePointsGroup: {
        id: 'delete-points-group',
        defaultMessage: 'Delete zone user access',
    },
    confirmDeletePointsGroup: {
        id: 'confirm-delete-points-group',
        defaultMessage:
            'Are you sure you want to delete the points group with name {name}? This action cannot be undone.',
    },
    generalInformation: {
        id: 'general-information',
        defaultMessage: 'General information',
    },
    generalInformationDescription: {
        id: 'general-information-description',
        defaultMessage: 'Provide general information about the parking',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    pricesDescription: {
        id: 'prices-description',
        defaultMessage: 'Prices description',
    },
    floors: {
        id: 'floors',
        defaultMessage: 'Floors',
    },
    parkingSpots: {
        id: 'parking-spots',
        defaultMessage: 'Parking spots',
    },
    allDayAccess: {
        id: 'all-day-access',
        defaultMessage: '24/7 access',
    },
    workingTime: {
        id: 'working-time',
        defaultMessage: 'Working time',
    },
    workingTimeDescription: {
        id: 'working-time-description',
        defaultMessage: 'Provide the parking work schedule',
    },
    capacity: {
        id: 'capacity',
        defaultMessage: 'Capacity',
    },
    limitCapacity: {
        id: 'limit-capacity',
        defaultMessage: 'Limit capacity',
    },
    generalSettings: {
        id: 'general-settings',
        defaultMessage: 'General settings',
    },
    integrations: {
        id: 'integrations',
        defaultMessage: 'Integrations',
    },
    paymentProviders: {
        id: 'payment-providers',
        defaultMessage: 'Payment providers',
    },
    enabled: {
        id: 'enabled',
        defaultMessage: 'Enabled',
    },
    parkingUUID: {
        id: 'parking-uuid',
        defaultMessage: 'Parking UUID',
    },
    parkingUUIDDescription: {
        id: 'parking-uuid-description',
        defaultMessage: 'Used for digital receipts in online payments and paystations',
    },
    apiEndpoint: {
        id: 'api-endpoint',
        defaultMessage: 'API Endpoint',
    },
    apiKey: {
        id: 'api-key',
        defaultMessage: 'API Key',
    },
    mediaEndpoint: {
        id: 'media-endpoint',
        defaultMessage: 'Media Endpoint',
    },
    photosPrefix: {
        id: 'photos-prefix',
        defaultMessage: 'Photos prefix',
    },
    adminUserId: {
        id: 'admin-user-id',
        defaultMessage: 'Admin User ID',
    },
    cameraStreamUsername: {
        id: 'camera-stream-username',
        defaultMessage: 'Camera Stream Username',
    },
    cameraStreamPassword: {
        id: 'camera-stream-password',
        defaultMessage: 'Camera Stream Password',
    },
    systemID: {
        id: 'system-id',
        defaultMessage: 'System ID',
    },
    city: {
        id: 'city',
        defaultMessage: 'City',
    },
    geoType: {
        id: 'geo-type',
        defaultMessage: 'Geo type',
    },
    geoTypePoint: {
        id: 'geo-type-point',
        defaultMessage: 'Point',
    },
    geoTypeArea: {
        id: 'geo-type-area',
        defaultMessage: 'Area',
    },
    geolocation: {
        id: 'geolocation',
        defaultMessage: 'Geolocation',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
    publicParking: {
        id: 'public-parking',
        defaultMessage: 'Public parking',
    },
    featuredParking: {
        id: 'featured-parking',
        defaultMessage: 'Featured parking',
    },
    onlinePayments: {
        id: 'online-payments',
        defaultMessage: 'Online payments',
    },
    disabled: {
        id: 'disabled',
        defaultMessage: 'Disabled',
    },
    start: {
        id: 'start',
        defaultMessage: 'Start',
    },
    end: {
        id: 'end',
        defaultMessage: 'End',
    },
    working: {
        id: 'working',
        defaultMessage: 'Working',
    },
    noResultsDescription: {
        id: 'parking-management-no-results-description',
        defaultMessage: 'There are no results for this section.',
    },
    clickToUpload: {
        id: 'click-to-upload',
        defaultMessage: 'Click to upload',
    },
    dragAndDrop: {
        id: 'drag-and-drop',
        defaultMessage: 'or drag and drop an image here',
    },
    coverPhoto: {
        id: 'cover-photo',
        defaultMessage: 'Cover photo',
    },
    coverPreview: {
        id: 'cover-preview',
        defaultMessage: 'Cover preview',
    },
    coverPhotoDescription: {
        id: 'cover-photo-description',
        defaultMessage: 'This will be displayed on your profile',
    },
    invalidHourFormat: {
        id: 'invalid-hour-format',
        defaultMessage: 'Invalid time format, HH:MM',
    },
    entryExitPoints: {
        id: 'entry-exit-points',
        defaultMessage: 'Entry and exit points',
    },
    entryExitPoint: {
        id: 'entry-exit-point',
        defaultMessage: 'Entry and exit point',
    },
    entryExitPointsDescription: {
        id: 'entry-exit-points-description',
        defaultMessage: 'Set the entrance and exits of your parking',
    },
    coordinates: {
        id: 'coordinates',
        defaultMessage: 'Coordinates',
    },
    maxHeight: {
        id: 'max-height',
        defaultMessage: 'Max height',
    },
    maxWidth: {
        id: 'max-width',
        defaultMessage: 'Max width',
    },
    metersAbbreviation: {
        id: 'meters-abbreviation',
        defaultMessage: 'm',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    enter: {
        id: 'enter',
        defaultMessage: 'Enter',
    },
    exit: {
        id: 'exit',
        defaultMessage: 'Exit',
    },
    entrance: {
        id: 'entrance',
        defaultMessage: 'Entrance',
    },
    deleteParkingGateway: {
        id: 'delete-parking-gateway',
        defaultMessage: 'Delete {parkingGatewayName}',
    },
    deleteParkingGatewayConfirmation: {
        id: 'delete-parking-gateway-confirmation',
        defaultMessage: 'Are you sure you want to delete {parkingGatewayName}?',
    },
    deleteParkingGatewaySuccess: {
        id: 'delete-parking-gateway-success',
        defaultMessage: 'Deleted successfully',
    },
    deleteParkingGatewaySuccessDetails: {
        id: 'delete-parking-gateway--success-details',
        defaultMessage: '{parkingGatewayName} successfully deleted',
    },
    addNewPoint: {
        id: 'add-new-point',
        defaultMessage: 'Add new point',
    },
    newEntryExit: {
        id: 'new-entry-exit',
        defaultMessage: 'New entry or exit point',
    },
    addNewPointDescription: {
        id: 'add-new-point-description',
        defaultMessage: 'Set the entrance and exits of your parking',
    },
    addNewPointSuccess: {
        id: 'add-new-point-success',
        defaultMessage: 'A new point created',
    },
    addNewPointSuccessDescription: {
        id: 'add-new-point-success-description',
        defaultMessage: 'A new point was successfully created.',
    },
    editEntryExit: {
        id: 'edit-entry-exit',
        defaultMessage: 'Edit entry or exit point',
    },
    editPointDescription: {
        id: 'edit-point-description',
        defaultMessage: 'Edit the entrance and exits of your parking',
    },
    editPointSuccess: {
        id: 'edit-point-success',
        defaultMessage: 'The point was updated',
    },
    editPointDescriptionSuccess: {
        id: 'edit-point-description-success',
        defaultMessage: 'The parking point was successfully updated.',
    },
    selectType: {
        id: 'select-type',
        defaultMessage: 'Select type',
    },
    pointsOfInterest: {
        id: 'points-of-interest',
        defaultMessage: 'Points of interest',
    },
    pointOfInterest: {
        id: 'point-of-interest',
        defaultMessage: 'Point of interest',
    },
    pointsOfInterestSubtitle: {
        id: 'points-of-interest-subtitle',
        defaultMessage: 'Locations and events that may be of interest to the client',
    },
    shoppingCenter: {
        id: 'shopping-center',
        defaultMessage: 'Shopping center',
    },
    park: {
        id: 'park',
        defaultMessage: 'Park',
    },
    museum: {
        id: 'museum',
        defaultMessage: 'Museum',
    },
    historicalSite: {
        id: 'historical-site',
        defaultMessage: 'Historical site',
    },
    gallery: {
        id: 'gallery',
        defaultMessage: 'Gallery',
    },
    stadium: {
        id: 'stadium',
        defaultMessage: 'Stadium',
    },
    hotel: {
        id: 'hotel',
        defaultMessage: 'Hotel',
    },
    restaurant: {
        id: 'restaurant',
        defaultMessage: 'Restaurant',
    },
    bar: {
        id: 'bar',
        defaultMessage: 'Bar',
    },
    hospital: {
        id: 'hospital',
        defaultMessage: 'Hospital',
    },
    deletedSuccessfully: {
        id: 'deleted-successfully',
        defaultMessage: 'Deleted successfully',
    },
    deletedSuccessfullyDescription: {
        id: 'deleted-successfully-description',
        defaultMessage: 'The point of interest was deleted successfully',
    },
    newPointOfInterest: {
        id: 'new-point-of-interest',
        defaultMessage: 'Add new point of interest',
    },
    selectPointsOfInterest: {
        id: 'select-points-of-interest',
        defaultMessage: 'Select a point of interest',
    },
    pointOfInterestAddedSuccessfully: {
        id: 'point-of-interest-added-successfully',
        defaultMessage: 'Added successfully',
    },
    pointOfInterestAddedSuccessfullyDescription: {
        id: 'point-of-interest-added-successfully-description',
        defaultMessage: 'The point of interest was added successfully',
    },
    amenities: {
        id: 'amenities',
        defaultMessage: 'Amenities',
    },
    amenitiesSubtitle: {
        id: 'amenities-subtitle',
        defaultMessage: 'Amenities that are available to your clients',
    },
    wc: {
        id: 'wc',
        defaultMessage: 'Restrooms',
    },
    underground: {
        id: 'underground',
        defaultMessage: 'Underground parking',
    },
    videoSurveillance: {
        id: 'video-surveillance',
        defaultMessage: 'Video surveillance',
    },
    invalidCoordinates: {
        id: 'invalid-coordinates',
        defaultMessage: 'Invalid coordinates',
    },
    notifications: {
        id: 'notifications',
        defaultMessage: 'Notifications',
    },
    notificationsSubtitle: {
        id: 'notifications-subtitle',
        defaultMessage: 'Choose the notification preferences of different roles',
    },
    recipientRoles: {
        id: 'recipient-roles',
        defaultMessage: 'Recipient roles',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    saveNotificationSettings: {
        id: 'save-notification-settings',
        defaultMessage: 'Save notification settings',
    },
    notification: {
        id: 'notification',
        defaultMessage: 'Notification',
    },
    notificationModalSubtitle: {
        id: 'notification-modal-subtitle',
        defaultMessage: 'Select which roles receive the notification',
    },
    notificationSetSuccessfully: {
        id: 'notification-set-successfully',
        defaultMessage: 'Notification set successfully',
    },
    newReservation: {
        id: 'new-reservation',
        defaultMessage: 'New reservation',
    },
    cancelledReservation: {
        id: 'cancelled-reservation',
        defaultMessage: 'Cancelled reservation',
    },
    createClientReservationNotification: {
        id: 'create-client-reservation-notification',
        defaultMessage: 'When clients create reservations from the client portal',
    },
    cancelClientReservationNotification: {
        id: 'cancel-client-reservation-notification',
        defaultMessage: 'When clients cancel their reservation from the client portal',
    },
    notificationSettings: {
        id: 'notification-settings',
        defaultMessage: 'Notification settings',
    },
    additionalServices: {
        id: 'additional-services',
        defaultMessage: 'Additional services',
    },
    additionalService: {
        id: 'additional-service',
        defaultMessage: 'Additional service',
    },
    manageAdditionalServices: {
        id: 'manage-additional-services',
        defaultMessage: 'Manage additional services for your parking',
    },
    module: {
        id: 'module',
        defaultMessage: 'Module',
    },
    optional: {
        id: 'optional',
        defaultMessage: 'Optional',
    },
    newService: {
        id: 'new-service',
        defaultMessage: 'Add new service',
    },
    newServiceAdded: {
        id: 'new-service-added',
        defaultMessage: 'New service added',
    },
    serviceCharge: {
        id: 'service-charge',
        defaultMessage: 'Service charge',
    },
    cancellationOption: {
        id: 'cancellation-option',
        defaultMessage: 'Cancellation option',
    },
    vehicleStay: {
        id: 'vehicle-stay',
        defaultMessage: 'Vehicle Stay',
    },
    selectModule: {
        id: 'selectModule',
        defaultMessage: 'Select module',
    },
    serviceDetails: {
        id: 'service-details',
        defaultMessage: 'Service details',
    },
    reservation: {
        id: 'reservation',
        defaultMessage: 'Reservation',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    vehicleStayBadge: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    newServiceAddedSuccessfully: {
        id: 'new-service-added-successfully',
        defaultMessage: 'New service added successfully',
    },
    addNewServiceDescription: {
        id: 'add-new-service-description',
        defaultMessage: 'Add a new service to your parking',
    },
    deleteService: {
        id: 'delete-service',
        defaultMessage: 'Delete service {name}',
    },
    deleteServiceConfirmation: {
        id: 'delete-service-confirmation',
        defaultMessage: 'Are you sure you want to delete {name}?',
    },
    serviceDeleted: {
        id: 'service-deleted',
        defaultMessage: 'Service deleted',
    },
    deletedServiceSuccessfully: {
        id: 'deleted-service-successfully',
        defaultMessage: 'Service {name} was successfully deleted',
    },
    enableStatusConfirmation: {
        id: 'enable-status-confirmation',
        defaultMessage: 'Are you sure you want to {status} service {name}?',
    },
    service: {
        id: 'service',
        defaultMessage: 'Service',
    },
    deactivateService: {
        id: 'deactivate-service',
        defaultMessage: 'Deactivate',
    },
    activateService: {
        id: 'activate-service',
        defaultMessage: 'Activate',
    },
    serviceUpdated: {
        id: 'service-updated',
        defaultMessage: 'Service updated',
    },
    serviceUpdatedSuccessfully: {
        id: 'service-updated-successfully',
        defaultMessage: 'Service {name} was successfully updated',
    },
    activeService: {
        id: 'active-service',
        defaultMessage: 'Active',
    },
    inactiveService: {
        id: 'inactive-service',
        defaultMessage: 'Inactive',
    },
    activateModalTitle: {
        id: 'activate-modal-title',
        defaultMessage: 'Activate {service}',
    },
    deactivateModalTitle: {
        id: 'deactivate-modal-title',
        defaultMessage: 'Deactivate {service}',
    },
    inCm: {
        id: 'in-cm',
        defaultMessage: 'in cm',
    },
    defaultCurrency: {
        id: 'default-currency',
        defaultMessage: 'Default currency',
    },
    ownPaymentOperator: {
        id: 'own-payment-operator',
        defaultMessage: 'Own payment operator',
    },
    paymentOperator: {
        id: 'payment-operator',
        defaultMessage: 'Payment operator',
    },
    username: {
        id: 'username',
        defaultMessage: 'Username',
    },
    myPosStoreId: {
        id: 'myPos-store-id',
        defaultMessage: 'Store ID',
    },
    myPosClientNumber: {
        id: 'myPos-client-number',
        defaultMessage: 'Client number',
    },
    myPosKeyIndex: {
        id: 'myPos-key-index',
        defaultMessage: 'Key index',
    },
    myPosCertificate: {
        id: 'myPos-certificate',
        defaultMessage: 'Certificate',
    },
    myPosPrivateKey: {
        id: 'myPos-private-key',
        defaultMessage: 'Private key',
    },
    paymentProviderChangeSuccess: {
        id: 'payment-provider-change-success',
        defaultMessage: 'Payment provider changed',
    },
    paymentProviderChangeSuccessDetails: {
        id: 'payment-provider-change-success-details',
        defaultMessage: 'The payment provider was successfully changed for {name}.',
    },
    paymentProviderDeleteErrorDetails: {
        id: 'payment-provider-delete-error-details',
        defaultMessage: 'An error occurred while trying to delete the payment provider for {name}.',
    },
    subdomain: {
        id: 'subdomain',
        defaultMessage: 'Subdomain',
    },
    digitalReceiptData: {
        id: 'digital-receipt-data',
        defaultMessage: 'Digital receipt data',
    },
    uic: {
        id: 'uic',
        defaultMessage: 'UIC',
    },
    taxNumber: {
        id: 'tax-number',
        defaultMessage: 'Tax number',
    },
    boricaAlreadyExists: {
        id: 'borica-already-exists',
        defaultMessage: 'The parking is already configured for payments with Borica.',
    },
    editService: {
        id: 'edit-service',
        defaultMessage: 'Edit service',
    },
    editServiceDescription: {
        id: 'edit-service-description',
        defaultMessage: 'Edit the service to your parking',
    },
    changeStatusService: {
        id: 'change-status-service',
        defaultMessage: '{status} service {name}',
    },
    deactivateServiceSubtitle: {
        id: 'deactivate-service-subtitle',
        defaultMessage: 'Deactivate',
    },
    activateServiceSubtitle: {
        id: 'activate-service-subtitle',
        defaultMessage: 'Activate',
    },
    reasonsForGuest: {
        id: 'reasons-for-guest',
        defaultMessage: 'Reason for guest',
    },
    reasons: {
        id: 'reasons',
        defaultMessage: 'Reasons',
    },
    reason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    addNewReasonDescription: {
        id: 'add-new-reason-description',
        defaultMessage: 'Add a new guest reason',
    },
    newReason: {
        id: 'new-reason',
        defaultMessage: 'New reason',
    },
    addNewReason: {
        id: 'add-new-reason',
        defaultMessage: 'Add new reason',
    },
    newReasonCreatedSuccess: {
        id: 'new-reason-created-success',
        defaultMessage: 'Reason created',
    },
    newReasonCreatedSuccessDescription: {
        id: 'new-reason-created-success-description',
        defaultMessage: 'New reason for guest was created successfully.',
    },
    deleteGuestReason: {
        id: 'delete-guest-reason',
        defaultMessage: 'Delete guest reason',
    },
    reasonDeleted: {
        id: 'reason-deleted',
        defaultMessage: 'Reason deleted',
    },
    reasonDeletedSuccessfully: {
        id: 'reason-deleted-successfully',
        defaultMessage: 'Reason for guest was deleted successfully.',
    },
    guestReasonDeleteConfirmation: {
        id: 'guest-reason-delete-confirmation',
        defaultMessage: 'Are you sure you want to delete this guest reason?',
    },
    editReasonForGuest: {
        id: 'edit-reason-for-guest',
        defaultMessage: 'Edit reason',
    },
    editReasonForGuestDescription: {
        id: 'edit-reason-for-guest-description',
        defaultMessage: 'Edit reason for guest',
    },
    reasonUpdated: {
        id: 'reason-updated',
        defaultMessage: 'Reason updated',
    },
    reasonUpdatedSuccessfully: {
        id: 'reason-updated-successfully',
        defaultMessage: 'The reason for guest was updated successfully.',
    },
    areaColor: {
        id: 'area-color',
        defaultMessage: 'Area Color',
    },
});
